'use client';

import type { ReactNode } from 'react';
import { useTranslations } from 'next-intl';
import { Box } from '@terra/ui-styled-system';
import { Checkbox, isArchivedTracePreview } from '@terra/ui-design-system';
import type { TracePreviewDto } from '@terra/shared-contracts-trace';
import { rowClickBlockerProps } from '../rowClickBlocker';
import { EXECUTIONS_SELECT_ALL_STATE } from './executions-list.model';
import { useExecutionsTableContext } from './ExecutionsTableContext';

function SelectionCheckboxFrame({ children }: { children: ReactNode }) {
  return (
    <Box
      w="full"
      h="full"
      display="flex"
      alignItems="center"
      justifyContent="center"
      {...rowClickBlockerProps}
    >
      {children}
    </Box>
  );
}

export function ExecutionsTableSelectAllHeader() {
  const t = useTranslations('proxy.executions.table');
  const { selectAllState, hasSelectableRows, isSelectionLocked, onSelectAll } =
    useExecutionsTableContext();

  return (
    <SelectionCheckboxFrame>
      <Checkbox
        size="sm"
        aria-label={t('selectAll')}
        checked={
          selectAllState === EXECUTIONS_SELECT_ALL_STATE.ALL
            ? true
            : selectAllState === EXECUTIONS_SELECT_ALL_STATE.SOME
              ? 'indeterminate'
              : false
        }
        disabled={!hasSelectableRows || isSelectionLocked}
        onCheckedChange={(details) => onSelectAll(details.checked === true)}
      />
    </SelectionCheckboxFrame>
  );
}

export function ExecutionsTableSelectionCell({
  trace,
}: {
  trace: TracePreviewDto;
}) {
  const t = useTranslations('proxy.executions.table');
  const { isTraceSelected, isSelectionLocked, onToggleTraceSelected } =
    useExecutionsTableContext();

  return (
    <SelectionCheckboxFrame>
      <Checkbox
        size="sm"
        aria-label={t('selectExecution')}
        checked={isTraceSelected(trace)}
        disabled={isArchivedTracePreview(trace) || isSelectionLocked}
        onCheckedChange={(details) =>
          onToggleTraceSelected({ trace, selected: details.checked === true })
        }
      />
    </SelectionCheckboxFrame>
  );
}
